<template>
	<div class="flex flex-col text-sm">
		<div
			v-for="i in 3"
			:key="i"
			class="flex flex-col lg:flex-row lg:items-center gap-3 py-4 border-b border-slate-100"
		>
			<!-- Ticker Badge Skeleton -->
			<div class="w-[120px]">
				<div class="h-8 bg-slate-300/[0.1] rounded animate-pulse"></div>
			</div>

			<!-- Title Section Skeleton -->
			<div class="w-[220px]">
				<div class="h-6 bg-slate-300/[0.1] rounded animate-pulse mb-2"></div>
				<div class="h-4 bg-slate-300/[0.1] rounded animate-pulse w-3/4"></div>
			</div>

			<!-- Content Section Skeleton -->
			<div class="flex flex-col max-w-[520px] flex-1">
				<div class="h-4 bg-slate-300/[0.1] rounded animate-pulse mb-2"></div>
				<div class="h-4 bg-slate-300/[0.1] rounded animate-pulse w-2/3 mb-2"></div>
				<div class="h-3 bg-slate-300/[0.1] rounded animate-pulse w-1/4"></div>
			</div>
		</div>
	</div>
</template>

<script setup>
// No props needed - pure skeleton component
</script>

<style scoped>
/* Enhanced pulsating animation */
@keyframes pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.7;
	}
}

.animate-pulse {
	animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Staggered animation for more natural loading effect */
.animate-pulse:nth-child(1) {
	animation-delay: 0s;
}
.animate-pulse:nth-child(2) {
	animation-delay: 0.15s;
}
.animate-pulse:nth-child(3) {
	animation-delay: 0.3s;
}

/* Different delay for each row */
div:nth-child(1) .animate-pulse {
	animation-delay: 0s;
}
div:nth-child(2) .animate-pulse {
	animation-delay: 0.2s;
}
div:nth-child(3) .animate-pulse {
	animation-delay: 0.4s;
}
</style>
